import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  currentMenu: {},
  userInfo: {},
  currentOpenMenu: '/transport',
  showSideNav: false,
  currentProjectId: window.localStorage.getItem('CURRENT_PROJECT_ID') || '',
  authUrlList: {},
  belongTo: 'SELF_PURCHASE',
  globalEnumCollection: {
    accountStatusEnum: {
      0: '已禁用',
      1: '正常',
      2: '已删除',
    },
    accountTypeEnum: {
      10: '超级管理员',
      20: '企业用户',
      21: '站点用户',
      22: '终端用户',
      30: '工厂用户',
      // 40: '设备用户',
    },
    accountTypeEnumByAdmin: {
      20: '企业用户',
      // 21: '站点用户',
      // 22: '终端用户',
      30: '工厂用户',
    },
    accountTypeEnumByCompany: {
      21: '站点用户',
      22: '终端用户',
    },
    wareHouseTypeEnum: {
      1: '制冷库',
      2: '常温库',
    },
    onlineFlagEnum: {
      0: '离线',
      1: '在线',
    },
    resultEnum: {
      0: '失败',
      1: '成功',
    },
    deviceTypeEnum: {
      0: '直连',
      1: '节点',
    },
    alarmTypeEnum: {
      1: '温度超限',
      2: '湿度超限',
      3: '低电',
      4: '断电',
      5: '离线',
    },
    alarmExecutorTypeEnum: {
      1: '短信',
      2: '邮件',
      3: '微信公众号',
    },
    readStatusEnum: {
      0: '未阅',
      1: '已阅',
    },
    recoverStatusEnum: {
      0: '未恢复',
      1: '已恢复',
    },
    locationAreaEnum: {
      1: '预冷区',
      2: '释冷区',
      3: '打包区',
      4: '回收区',
    },
    iceBoxProcessStatusEnum: {
      0: '总冰盒',
      1: '待预冷',
      2: '预冷中',
      3: '预冷完成',
      4: '释冷中',
      5: '释冷完成',
      6: '释冷过久',
      7: '运输中',
      8: '运输完成',
    },
    iceBoxProcessStatusWithoutSiteEnum: {
      1: '待预冷',
      2: '预冷中',
      3: '预冷完成',
      4: '释冷中',
      5: '释冷完成',
      6: '释冷过久',
    },
    transportStatusEnum: {
      0: '待运输',
      1: '运输中',
      2: '运输完成',
      3: '取消运输',
    },
    sendParamStatusEnum: {
      0: '未下发',
      1: '下发中',
      2: '下发完成',
    },
    shutdownStatusEnum: {
      0: '未操作',
      1: '关机中',
      2: '关机成功',
    },
    boxStatusEnum: {
      1: '可用',
      2: '在运',
      3: '待回收',
    },
    boxRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    iceBoxRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    deviceRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    tempStatusEnum: {
      1: '正常',
      2: '超温',
    },
    assetTypeEnum: {
      0: '箱子',
      1: '冰盒',
      2: '记录仪',
      3: '冰盒架',
      4: '冰盒托盘',
      5: '冰盒筐',
    },
    operateTypeEnum: {
      1: '入库',
      2: '出库',
      3: '打包',
      4: '回收',
      5: '解绑',
    },
    // 冰盒出入库的载体类型
    carrierTypeEnum: {
      1: '冰盒架',
      2: '冰盒托盘',
      3: '筐',
      4: '/',
    },
    // GPS开关
    gpsSwitchEnum: {
      0: '关闭',
      1: '开启',
    },
    // 亮屏时间
    brightScreenEnum: {
      0: '常亮',
      1: '15秒',
      2: '30秒',
      10: '1分钟',
      20: '2分钟',
      30: '3分钟',
      40: '4分钟',
      50: '5分钟',
    },
    // 设备事件
    deviceEventEnum: {
      0: '开机',
      1: '关机',
      2: '重启',
      3: '断开电源',
      4: '连接电源',
      5: '开箱',
      6: '关箱',
      7: '短信下发参数',
      8: '平台下发参数',
    },
    whetherEnum: {
      0: '否',
      1: '是',
    },
    belongToEnum: {
      SELF_PURCHASE: '自购',
      LEASE: '租赁',
    },
    deviceStatusEnum: {
      0: '禁用',
      1: '启用',
      2: '损坏',
    },
    maintenanceResultEnum: {
      1: '√',
      2: '×',
      /* 3: '○',
      4: '△', */
    },
  },
  menuList: [
    { icon: 'el-icon-monitor', title: '设备查看', url: '/transport-monitor-forDeviceUser', authUserType: [40] },
    {
      icon: 'el-icon-truck',
      title: '运输管理',
      url: '/transport',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '运输列表',
          url: '/transport-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '运输监控',
          url: '/transport-monitor',
          authUserType: [10, 20, 21],
        },
        {
          title: '运单管理',
          url: '/transportOrder-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '分组管理',
          url: '/group-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '分组设备',
          url: '/group-device',
          authUserType: [10, 20, 21],
        },
        {
          title: '设备事件',
          url: '/device-event',
          authUserType: [10, 20, 21],
        },
      ],
    },
    { icon: 'el-icon-receiving', title: '冰盒流程管理', url: '/iceBox-process', authUserType: [10, 20, 21] },
    {
      icon: 'el-icon-office-building',
      title: '库房管理',
      url: '/location',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '库房设置',
          url: '/location-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
    { icon: 'el-icon-receiving', title: '设备参数', url: '/device-param', authUserType: [10, 20, 21] },
    /* { icon: 'el-icon-coin', title: '资产管理', url: '/333-list' }, */
    {
      icon: 'el-icon-coin',
      title: '资产管理',
      url: '/assets',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '仓库管理',
          url: '/warehouse-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰箱管理',
          url: '/fridge-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '箱管理',
          url: '/box-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰盒管理',
          url: '/iceBox-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰盒架',
          url: '/iceBoxShelf-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰盒托盘',
          url: '/iceBoxPallet-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '传感器',
          url: '/device-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '维保管理',
          url: '/device-maintenance-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '设备列表',
          url: '/device-table-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-bell',
      title: '报警信息',
      url: '/alarm',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '报警信息管理',
          url: '/alarm-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '报警项目管理',
          url: '/alarmExecutor-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-s-tools',
      title: '系统管理',
      url: '/config',
      authUserType: [10, 20],
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '账号管理',
          url: '/account-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '日志管理',
          url: '/box-log-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '操作日志',
          url: '/log-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '企业管理',
          url: '/company-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '站点管理',
          url: '/station-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '全局配置',
          url: '/mail-config',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '数据备份',
          url: '/data-backup',
          authUserType: [10, 20],
        },
      ],
    },
  ],
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js